export const notes = "";

export const contactPreferences = {
  email: true,
  call: false,
  text: false
};
